// removed by extract-text-webpack-plugin
module.exports = {"outer":"_1TSv"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Contact/ContactForm/ContactForm.scss
// module id = mVft
// module chunks = 0